import type { CountryType } from "../@types/generic";
import { pushDataLayer } from "./dataLayer";
import { isDachProduct } from "./isDachProduct";

const ADFRAMEWORK_LOAD_TIMEOUT = 5000;

let isTcfLoadedTracked = false;

const trackAdframeworkLoad = (window: Window): void => {
    const timeout = setTimeout(() => {
        pushDataLayer({
            type: "loadTracking",
            event: "adframework_load",
            loaded: false,
        });
    }, ADFRAMEWORK_LOAD_TIMEOUT);

    window.adHandler = window.adHandler ?? {};
    window.adHandler.cmd = window.adHandler.cmd ?? [];
    // The ad framework processes the cmd queue as soon as it is loaded.
    // If this happens after the timeout, adframework_load: true is pushed after the false.
    window.adHandler.cmd.push(() => {
        clearTimeout(timeout);
        pushDataLayer({
            type: "loadTracking",
            event: "adframework_load",
            loaded: true,
        });
    });
};

// Called when the user accepts all in the CMP or has already accepted in the past.
export const trackTcfLoaded = (window: Window, country: CountryType): void => {
    if (isTcfLoadedTracked || !isDachProduct(country)) {
        return;
    }
    isTcfLoadedTracked = true;

    pushDataLayer({
        type: "loadTracking",
        event: "tcf_load",
        loaded: true,
    });

    trackAdframeworkLoad(window);
};
